import script from "./bcIntro.vue?vue&type=script&lang=ts&setup=true"
export * from "./bcIntro.vue?vue&type=script&lang=ts&setup=true"

import "./bcIntro.vue?vue&type=style&index=0&id=4ffc1e8c&lang=scss&scoped=true"
import "./bcIntro.vue?vue&type=style&index=1&id=4ffc1e8c&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ffc1e8c"]])

export default __exports__